import React, { FC, ReactNode } from 'react';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Box, Label } from 'roo-ui/components';

const StyledLabel = styled(Label)`
  font-size: ${themeGet('fontSizes.base')};
  color: ${themeGet('colors.greys.steel')};
`;

export interface FieldLabelProps {
  htmlFor: string;
  children: ReactNode;
  mb?: string | number | string[] | number[];
  [x: string]: any;
}

export const FieldLabel: FC<FieldLabelProps> = ({
  htmlFor,
  children,
  mb,
  ...rest
}) => (
  <Box {...rest}>
    <StyledLabel htmlFor={htmlFor} mb={mb} data-testid="field-label">
      {children}
    </StyledLabel>
  </Box>
);
